import React, { FC } from 'react';
import { CampaignWizardMode } from '../../../../models/enums';

import styles from './stepsNavigation.module.scss';

/**
 * Shows roadmap with a marked current step
 * */

type StepsNavigationPropTypes = {
    currentStep: number;
    mode?: CampaignWizardMode;
    isNewWizard?: boolean;
}

const steps = [0, 1, 2, 3];
const newWizardSteps = [0, 1, 2];

const StepsNavigation: FC<StepsNavigationPropTypes> = ({ currentStep, mode, isNewWizard }) => {
    // calculate className based on current step
    const stepClassName = (step: number) => {
        if (currentStep === step) return styles.selectedStep;
        if (currentStep > step) return styles.passedStep;
        return styles.step
    };

    return (
        <ul className={isNewWizard ? styles.newWizardStepList : styles.stepList}>
            {(isNewWizard ? newWizardSteps : steps).map(step => (
                <li
                    key={step}
                    className={stepClassName(step)}
                >
                    {step + 1}
                </li>
            ))}
        </ul>
    );
};

export default StepsNavigation;